import Backdrop from "../../imports/ui-components/backdrop/Backdrop";
import Button from "../../imports/ui-components/button/Button";
import Input from "../../imports/ui-components/input/Input";
import React, { useState } from "react";
import Logo from "../../utilities/logo/Logo";
import { validateLogin } from "../../utilities/functions/validateLogin";
import styles from "./Login.module.css";

const CONTROLS = ["username", "password"];

const Login = (props) => {
	const [isValid, toggleValid] = useState(true);
	const [controls, setControls] = useState({
		username: {
			elementType: "input",
			elementConfig: {
				type: "text",
				placeholder: "Username",
			},
			value: "",
			validation: {
				required: true,
			},
			valid: false,
			touched: false,
		},
		password: {
			elementType: "input",
			elementConfig: {
				type: "password",
				placeholder: "Password",
			},
			value: "",
			validation: {
				required: true,
				minLength: 6,
			},
			valid: false,
			touched: false,
		},
	});

	const checkValidity = (value, rules) => {
		let isValid = true;
		if (!rules) {
			return true;
		}

		if (rules.required) {
			isValid = value.trim() !== "" && isValid;
		}

		if (rules.minLength) {
			isValid = value.length >= rules.minLength && isValid;
		}

		if (rules.maxLength) {
			isValid = value.length <= rules.maxLength && isValid;
		}

		if (rules.isEmail) {
			const pattern = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
			isValid = pattern.test(value) && isValid;
		}

		if (rules.isNumeric) {
			const pattern = /^\d+$/;
			isValid = pattern.test(value) && isValid;
		}

		return isValid;
	};
	const inputChangedHandler = (event, controlName) => {
		const updatedControls = {
			...controls,
			[controlName]: {
				...controls[controlName],
				value: event.target.value,
				valid: checkValidity(
					event.target.value,
					controls[controlName].validation
				),
				touched: true,
			},
		};
		setControls(updatedControls);
	};

	const submitHandler = async (event) => {
		event.preventDefault();
		const booled = await validateLogin(
			controls.username.value,
			controls.password.value
		);

		if (booled !== false) {
			props.submitted(booled);
			props.clicked(false);
		} else {
			toggleValid(false);
		}
	};

	const form = CONTROLS.map((key) => ({
		id: key,
		config: controls[key],
	})).map((formElement) => (
		<Input
			key={formElement.id}
			elementType={formElement.config.elementType}
			elementConfig={formElement.config.elementConfig}
			value={formElement.config.value}
			invalid={!formElement.config.valid}
			shouldValidate={formElement.config.validation}
			touched={formElement.config.touched}
			changed={(event) => inputChangedHandler(event, formElement.id)}
		/>
	));

	return (
		<div className={styles.login}>
			<Backdrop
				show
				clicked={async () => await props.clicked(false)}
				zIndex={-1}
			/>
			<div className={styles.loginPage}>
				<button
					onClick={async () => await props.clicked(false)}
					className={styles.close}
				>
					X
				</button>
				<div className={styles.logo}>
					<Logo source="geomatics" />
				</div>
				{props.status ? (
					<>
						Logged in as {props.data.username}
						<button
							onClick={() => {
								props.submitted(false);
							}}
						>
							LOGOUT
						</button>
					</>
				) : (
					<>
						Login Page
						<form className={styles.form} onSubmit={submitHandler}>
							{form}
							{isValid ? null : (
								<p className={styles.invalid}>Invalid Credentials. Try Again</p>
							)}
							<Button btnType="Success">SUBMIT</Button>
						</form>
					</>
				)}
			</div>
		</div>
	);
};

export default Login;
